export default __webpack_public_path__ + "static/shade2-9d248d9d7fb0e14bc920206f07be90c8.png";